export function removeQueryParams(url: string) {
  const parsedUrl = new URL(url)

  return parsedUrl.origin + parsedUrl.pathname
}
